module.exports = __webpack_public_path__ + "60298c56ad7049093a8660adee871c4a.pdf";